export default {
  major: 'Major',
  moderate: 'Moderate',
  minor: 'Minor',
};
